import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, useFetch } from "../lib/api";
import { useApp } from "../context/AppContext";
import { timeAgo } from "../lib/fmt";

export function ChatThread({ mid }) {
  const { sp, user } = useApp();
  const { data, reload } = useFetch(sp(`/missions/${mid}/messages`), 6000);
  const [text, setText] = useState("");
  const endRef = useRef(null);
  const count = data?.length || 0;

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [count]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      await api.post(sp(`/missions/${mid}/messages`), { text });
      setText("");
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (!data) return <div className="h-20 animate-pulse rounded-2xl bg-slate-100" />;
  return (
    <div data-testid="chat-thread">
      <div className="space-y-3">
        {data.length === 0 && <p className="py-4 text-center text-sm text-slate-400">Pas encore de message.</p>}
        {data.map((m) => {
          const mine = m.user_id === user.id;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid="chat-message">
              <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 ${mine ? "rounded-br-md bg-teal-600 text-white" : "rounded-bl-md border border-slate-200 bg-white"}`}>
                {!mine && <div className="mb-0.5 text-xs font-bold text-teal-700">{m.name}</div>}
                <p className="whitespace-pre-wrap text-[15px] leading-snug">{m.text}</p>
                <div className={`mt-1 text-[10px] ${mine ? "text-teal-100" : "text-slate-400"}`}>{timeAgo(m.at)}</div>
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="mt-4 flex gap-2 rounded-2xl border border-slate-200 bg-white p-2">
        <input className="min-h-[44px] flex-1 bg-transparent px-2 text-base outline-none" placeholder="Écrire…" value={text} onChange={(e) => setText(e.target.value)} data-testid="chat-input" />
        <button className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-600 text-white active:scale-95" data-testid="chat-send-btn" aria-label="Envoyer"><Send className="h-4 w-4" /></button>
      </form>
    </div>
  );
}
